module.exports = __webpack_public_path__ + "static/media/spec_activity.27fa768c.png";